<template>
  <div>
    <!-- 消息通知遮罩层、 -->
    <PopopMessageGuide />
    <!-- 选择身份的遮罩层 -->
    <!-- <OverlayIdentityChoice /> -->
    <!-- 选择用户年级、版本的弹窗 -->
    <PopupVersionSetting />
    <!-- 绑定手机号 -->
    <PopupBindPhone />
    <!-- 首页红包碎片 -->
    <PopupFragments />
    <!-- vip过期一个月 -->
    <!-- <PopupVip /> -->
    <!-- 首页广告 -->
    <PopupAdvert />
    <!-- 添加历史书籍到书架 -->
    <OverlayAddHistoryBook />
    <!-- 分享遮罩层 -->
    <OverlayShare />
    <!-- 学管师弹窗 -->
    <!-- <OverlayXueGuanAlert /> -->
    <!-- textbookDetails 页面弹窗广告 -->
    <PopupAdvertAnswerDetail />
    <!-- textbookDetails 页面提示为旧书 -->
    <!-- <OverlayAnswerDetailOldBook /> -->
    <!-- textbookDetails 暑假作业订阅弹窗 -->
    <!-- <PopupSummerAssignmentSubscription /> -->
    <!-- 答案页弹窗 -->
    <PopupAnswerRights />
    <!-- 获取学管师发生的红包碎片 -->
    <PopupGetRed />
    <!-- 学习顾问首页弹框 -->
    <!-- <StudyCounselor /> -->
    <!-- 非会员首页展示【我的书架】，已购书籍模块下线  // 下线弹窗 单本已购-->
    <!--    <PopupMyBookrack />-->
    <!-- 已购书籍记录可以在[个人中心]查看哦~ -->
    <!--    <PopupPurchasedBookRemind />-->
  </div>
</template>

<script>
import PopopMessageGuide from './PopopMessageGuide'
// import OverlayIdentityChoice from './OverlayIdentityChoice'
import PopupVersionSetting from './PopupVersionSetting'
import PopupBindPhone from './PopupBindPhone'
import PopupFragments from './PopupFragments'
// import PopupVip from './PopupVip'
import PopupAdvert from './PopupAdvert'
import PopupAdvertAnswerDetail from './PopupAdvertAnswerDetail'
import OverlayAddHistoryBook from './OverlayAddHistoryBook'
import OverlayShare from './OverlayShare'
import PopupAnswerRights from './PopupAnswerRights'
// import PopupMyBookrack from './PopupMyBookrack'
// import PopupPurchasedBookRemind from './PopupPurchasedBookRemind'
// import OverlayAnswerDetailOldBook from './OverlayAnswerDetailOldBook'
import PopupSummerAssignmentSubscription from './PopupSummerAssignmentSubscription'
import PopupGetRed from './PopupGetRed'
// import OverlayXueGuanAlert from './OverlayXueGuanAlert'
// import StudyCounselor from '../../pages/vipHome/route/index/studyCounselor/index'
// import { clear } from '../../plugin/popup'

export default {
  components: {
    PopopMessageGuide,
    // OverlayIdentityChoice,
    PopupVersionSetting,
    PopupBindPhone,
    PopupFragments,
    // PopupVip,
    PopupAdvert,
    PopupAdvertAnswerDetail,
    // OverlayAnswerDetailOldBook,
    OverlayShare,
    PopupAnswerRights,
    // 下线弹窗 单本已购
    // PopupMyBookrack,
    // PopupPurchasedBookRemind,
    PopupSummerAssignmentSubscription,
    PopupGetRed,
    OverlayAddHistoryBook
    // OverlayXueGuanAlert,
    // StudyCounselor
  },
  mounted() {}
}
</script>

<style lang="scss" scoped></style>
